export const CLIENT_DASHBOARD_QUERY = '/client-dashboard';
